import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

type AttackPathsQueryFilters = {
  resourceId?: string;
};

const SECURITY_ATTACK_PATHS_QUERY_KEY = 'security-attack-paths';

const getAttackPathsQueryKey = (filters?: AttackPathsQueryFilters) =>
  [SECURITY_ATTACK_PATHS_QUERY_KEY, filters] as const;

const getAttackPathsQueryOptions = (filters?: AttackPathsQueryFilters) =>
  queryOptions({
    queryKey: getAttackPathsQueryKey(filters),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getAttackPaths(filters);
      return data.items || null;
    },
  });

export const useAttackPathsQuery = (filters?: AttackPathsQueryFilters) => {
  const {
    isLoading,
    data: attackPaths,
    error,
    refetch,
  } = useQuery(getAttackPathsQueryOptions(filters));

  return { isLoading, attackPaths: attackPaths || undefined, error, refetch };
};
